<template>
  <div class="dblb-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form ref="form" :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="下派日期">
              <el-date-picker
                v-model="searchForm.assignTime"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="计划完成">
              <el-date-picker
                v-model="searchForm.planTime"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="排产年份">
              <el-date-picker
                style="width: 120px"
                v-model="searchForm.producYear"
                format="yyyy年"
                value-format="yyyy"
                type="year"
                placeholder="选择年份">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="车间">
              <el-select v-model="searchForm.factory" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option v-for="item in factoryList" v-if="item.brand===0||group.dBrand===0||group.dBrand===item.brand" :key="item.factory_id" :label="item.simple_name"  :value="item.factory_id" />
              </el-select>
            </el-form-item>
            <el-form-item label="在线天数">
              <el-input  v-model.number="searchForm.onlineDay" style="width:200px" placeholder="在线天数" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item label="关键字">
              <el-input v-model="searchForm.search" style="width:200px" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search('form')">搜索</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-row>
              <el-col :span="24">
                <el-table
                  :data="tableData"
                  stripe
                  v-loading="tableLoading"
                  style="width: 100%">
                  <el-table-column
                    label="订单号"
                    width="130"
                    fixed
                    show-overflow-tooltip
                    prop="ordernum">
                  </el-table-column>
                  <el-table-column
                    label="生产单号"
                    width="120"
                    fixed
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{scope.row.produnum}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="经销商"
                    width="120"
                    show-overflow-tooltip
                    prop="allname">
                  </el-table-column>
                  <el-table-column
                    label="详细地址"
                    width="180"
                    show-overflow-tooltip
                    prop="address">
                  </el-table-column>
                  <el-table-column
                    label="车间"
                    width="120"
                    align="center"
                    show-overflow-tooltip
                    prop="abbname">
                  </el-table-column>
                  <el-table-column
                    label="在线天数"
                    width="80"
                    align="center"
                    show-overflow-tooltip
                    prop="onlineDay">
                  </el-table-column>
                  <el-table-column
                    label="排产时间"
                    width="120"
                    align="center"
                    show-overflow-tooltip
                    prop="scheduleTime">
                  </el-table-column>
                  <el-table-column
                    label="计划交期"
                    width="120"
                    align="center"
                    show-overflow-tooltip
                    prop="planned">
                  </el-table-column>
                  <el-table-column
                    label="排产人"
                    width="100"
                    align="center"
                    show-overflow-tooltip
                    prop="scheduleName">
                  </el-table-column>
                  <el-table-column
                    label="木工"
                    width="140"
                    fixed="right"
                    prop="woodtime">
                    <template slot-scope="scope">
                      <div>计划：{{ scope.row.expWoodtime }}</div>
                      <div>完成：
                        <span v-if="scope.row.woodIsOver===1" style="color: #67C23A">{{ scope.row.woodtime }}</span>
                        <span v-if="scope.row.woodIsOver===2" style="color: #F56C6C">{{ scope.row.woodtime }}</span>
                        <span v-if="scope.row.woodIsOver!==1&&scope.row.woodIsOver!==2&&scope.row.woodtime!==null&&scope.row.woodtime!==''&&scope.row.woodtime!==undefined">{{ scope.row.woodtime }}</span>
                        <span v-if="scope.row.woodtime===null || scope.row.woodtime===''" >
                          <span v-if="scope.row.doormark==0" style="color:#f56c6c">未全检</span>
                          <el-button v-if="scope.row.doormark==1" @click="openMgDetails(scope.row)" type="text" icon="el-icon-search" style="font-size: 13px;color:#E6A23C">全检中</el-button>
                        </span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="油漆"
                    width="140"
                    fixed="right"
                    prop="painttime">
                    <template slot-scope="scope">
                      <div>计划：{{ scope.row.expPainttime }}</div>
                      <div>完成：
                        <span v-if="scope.row.paintIsOver===1" style="color: #67C23A">{{ scope.row.painttime }}</span>
                        <span v-if="scope.row.paintIsOver===2" style="color: #F56C6C">{{ scope.row.painttime }}</span>
                        <span v-if="scope.row.paintIsOver!==1&&scope.row.paintIsOver!==2&&scope.row.painttime!==null&&scope.row.painttime!==''&&scope.row.painttime!==undefined">{{ scope.row.painttime }}</span>
                        <span v-if="scope.row.painttime===null || scope.row.painttime===''">
                          <span v-if="scope.row.paintmark==0" style="color:#f56c6c">未全检</span>
                          <el-button v-if="scope.row.paintmark==1" @click="openYqDetails(scope.row)" type="text" icon="el-icon-search" style="font-size: 13px;color:#E6A23C">全检中</el-button>
                        </span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="打包"
                    width="140"
                    fixed="right"
                    prop="packtime">
                    <template slot-scope="scope">
                      <div>计划：{{ scope.row.expPacktime }}</div>
                      <div>完成：
                        <span v-if="scope.row.packIsOver===1" style="color: #67C23A">{{ scope.row.packtime }}</span>
                        <span v-if="scope.row.packIsOver===2" style="color: #F56C6C">{{ scope.row.packtime }}</span>
                        <span v-if="scope.row.packIsOver!==1&&scope.row.packIsOver!==2&&scope.row.packtime!==null&&scope.row.packtime!==''&&scope.row.packtime!==undefined">{{ scope.row.packtime }}</span>
                        <span v-if="scope.row.packtime===null || scope.row.packtime===''">暂无</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="入库"
                    width="140"
                    fixed="right"
                    prop="intime">
                    <template slot-scope="scope">
                      <div>计划：{{ scope.row.expIntime }}</div>
                      <div>完成：
                        <span v-if="scope.row.inIsOver===1" style="color: #67C23A">{{ scope.row.intime }}</span>
                        <span v-if="scope.row.inIsOver===2" style="color: #F56C6C">{{ scope.row.intime }}</span>
                        <span v-if="scope.row.inIsOver!==1&&scope.row.inIsOver!==2&&scope.row.intime!==null&&scope.row.intime!==''&&scope.row.intime!==undefined">{{ scope.row.intime }}</span>
                        <span v-if="scope.row.intime===null || scope.row.intime===''">暂无</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="出库"
                    width="140"
                    fixed="right"
                    prop="outtime">
                    <template slot-scope="scope">
                      <div>计划：
                        <span>{{ scope.row.expOuttime }}</span>
                      </div>
                      <div>完成：
                        <span v-if="scope.row.outIsOver===1" style="color: #67C23A">{{ scope.row.outtime }}</span>
                        <span v-if="scope.row.outIsOver===2" style="color: #F56C6C">{{ scope.row.outtime }}</span>
                        <span v-if="scope.row.outIsOver!==1&&scope.row.outIsOver!==2&&scope.row.outtime!==null&&scope.row.outtime!==''&&scope.row.outtime!==undefined">{{ scope.row.outtime }}</span>
                        <span v-if="scope.row.outtime===null || scope.row.outtime===''">暂无</span>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="mgtitle"
      :visible.sync="mgeditVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
        <el-table
          size="small"
          v-loading="getMgLoading"
          stripe
          :data="detailMgTableData"
          style="width: 100%">
          <el-table-column
            v-for="(item,index) in detailMgTableColumn"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            :fixed="index===0?true:false"
            align="center">
            <template slot-scope="scope">
              <span v-if="index===0">{{scope.row[item.prop]}}</span>
              <i v-if="index!==0&&scope.row[item.prop]===0" style="color:#E6A23C" class="el-icon-time"></i>
              <i v-if="index!==0&&scope.row[item.prop]===1" style="color:#67C23A" class="el-icon-success"></i>
            </template>
          </el-table-column>
        </el-table>
    </el-dialog>
    <el-dialog
      :title="yqtitle"
      :visible.sync="yqeditVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
        <el-table
          size="small"
          v-loading="getYqLoading"
          stripe
          :data="detailYqTableData"
          style="width: 100%">
          <el-table-column
            v-for="item in detailYqTableColumn"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            align="center">
            <template slot-scope="scope">
              <i v-if="scope.row[item.prop]===0" style="color:#E6A23C" class="el-icon-time"></i>
              <i v-if="scope.row[item.prop]===1" style="color:#67C23A" class="el-icon-success"></i>
            </template>
          </el-table-column>
        </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import {
  getFactoryList,
  getGroupInfoByUser,
  getOrderSchedule,
  getPaintCheckDetail,
  getWoodCheckDetail
} from '@/api/erp'

export default {
  name: 'scdt',
  computed: {
    user: getUser
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      searchForm: {
        search: '',
        onlineDay: null,
        factory: '',
        assignTime: null,
        planTime: null,
        producYear: null
      },
      tableData: [],
      factoryList: [],
      tableLoading: false,
      mgeditVisible: false,
      mgtitle: '木工全检详情',
      getMgLoading: false,
      detailMgTableData: [],
      detailMgTableColumn: [],
      yqtitle: '油漆全检详情',
      yqeditVisible: false,
      getYqLoading: false,
      detailYqTableData: [],
      detailYqTableColumn: [],
      group: {
        dBrand: 1
      }
    }
  },
  created() {
    this.getData()
    getGroupInfoByUser({ groupid: this.user.dGroupid }).then(response => {
      this.group = response.data
    })
    this.getFactoryList()
  },
  methods: {
    openMgDetails(row) {
      this.mgtitle = row.produnum + '木工全检详情'
      this.mgeditVisible = true
      this.getMgLoading = true
      getWoodCheckDetail({ orderid: row.orderid }).then(response => {
        let groupArr = []
        if (response.data.door_group === 1) {
          let isdis = false
          let num = 0
          for (let p of response.data.woodfullList) {
            if (p.group === 1) {
              num++
            }
          }
          if (num === response.data.processesList.length) {
            isdis = true
          }
          groupArr.push({ name: '房门组', val: 1, isdis: isdis })
        }
        if (response.data.cabinet_group === 1) {
          let isdis = false
          let num = 0
          for (let p of response.data.woodfullList) {
            if (p.group === 2) {
              num++
            }
          }
          if (num === response.data.processesList.length) {
            isdis = true
          }
          groupArr.push({ name: '柜体组', val: 2, isdis: isdis })
        }
        if (response.data.panel_group === 1) {
          let isdis = false
          let num = 0
          for (let p of response.data.woodfullList) {
            if (p.group === 3) {
              num++
            }
          }
          if (num === response.data.processesList.length) {
            isdis = true
          }
          groupArr.push({ name: '饰面组', val: 3, isdis: isdis })
        }
        if (response.data.door_group !== 1 && response.data.cabinet_group !== 1 && response.data.panel_group !== 1) {
          let isdis = false
          let num = 0
          for (let p of response.data.woodfullList) {
            if (p.group === 4) {
              num++
            }
          }
          if (num === response.data.processesList.length) {
            isdis = true
          }
          groupArr.push({ name: '色板/其他', val: 4, isdis: isdis })
        }
        let processArr = []
        let column = [{ prop: 'group', label: '分组', width: 80 }]
        for (let p of response.data.processesList) {
          let isdis = false
          let num = 0
          for (let w of response.data.woodfullList) {
            if (w.spid === p.dSpid) {
              num++
            }
          }
          if (num === groupArr.length) {
            isdis = true
          }
          processArr.push({ name: p.dName, val: p.dSpid, isdis: isdis })
          let width = 80
          if (p.dName.length > 4) {
            width = 130
          }
          column.push({ prop: 'gx' + p.dSpid, label: p.dName, width: width })
        }
        this.detailMgTableColumn = column
        let tableData = []
        for (let g of groupArr) {
          let d = { 'group': g.name }
          for (let p of response.data.processesList) {
            let isdis = 0
            for (let w of response.data.woodfullList) {
              if (w.spid === p.dSpid && w.group === g.val) {
                isdis = 1
                break
              }
            }
            d[`gx${p.dSpid}`] = isdis
          }
          tableData.push(d)
        }
        this.detailMgTableData = tableData
        this.getMgLoading = false
      }).catch(() => {
        this.getMgLoading = false
      })
    },
    openYqDetails(row) {
      this.yqtitle = row.produnum + '油漆全检详情'
      this.yqeditVisible = true
      this.getYqLoading = true
      getPaintCheckDetail({ orderid: row.orderid }).then(response => {
        let processArr = []
        let column = []
        let d = {}
        for (let p of response.data.processesList) {
          processArr.push({ name: p.dName, val: p.dSpid, isdis: p.is_complet })
          let width = 80
          if (p.dName.length > 4) {
            width = 130
          }
          column.push({ prop: 'gx' + p.dSpid, label: p.dName, width: width })
          d[`gx${p.dSpid}`] = p.is_complet
        }
        let tableData = []
        tableData.push(d)
        this.detailYqTableColumn = column
        this.detailYqTableData = tableData
        this.getYqLoading = false
      }).catch(() => {
        this.getYqLoading = false
      })
    },
    getFactoryList() {
      getFactoryList().then(response => {
        this.factoryList = response.data
      })
    },
    Search() {
      if (this.searchForm.onlineDay !== null && this.searchForm.onlineDay !== '') {
        if (!(/(^[1-9]\d*$)/.test(this.searchForm.onlineDay))) {
          this.$message({
            message: '请输入正确的天数',
            type: 'error'
          })
          return false
        }
      }
      this.currentPage = 1
      this.getData()
      this.searchForm.search = this.searchForm.search.trim()
    },
    getData() {
      this.tableLoading = true
      let assignStart = ''
      let assignEnd = ''
      let onlineStart = ''
      let onlineEnd = ''
      if (this.searchForm.assignTime !== null && this.searchForm.assignTime.length === 2) {
        assignStart = this.searchForm.assignTime[0]
        assignEnd = this.searchForm.assignTime[1]
      }
      if (this.searchForm.planTime !== null && this.searchForm.planTime.length === 2) {
        onlineStart = this.searchForm.planTime[0]
        onlineEnd = this.searchForm.planTime[1]
      }
      const data = {
        page: this.currentPage,
        limit: this.pageSize,
        keyword: this.searchForm.search,
        factory: this.searchForm.factory,
        onlineDay: this.searchForm.onlineDay,
        producYear: this.searchForm.producYear,
        assignStart: assignStart,
        assignEnd: assignEnd,
        onlineStart: onlineStart,
        onlineEnd: onlineEnd,
        userid: this.user.dUserid,
        groupid: this.user.dGroupid,
        role: this.user.role
      }
      getOrderSchedule(data).then(response => {
        this.tableData = response.data
        this.total = response.total
        this.tableLoading = false
      })
    },
    handleSizeChange(val) {
      this.currentPage = 1
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped>
  .dblb-container {
    .tcf-row{
      .card{
        .card-body{
          .card-title{
            .search-mode{
              width: 300px;
              position: relative;
              float: right;
              margin-top: -10px;
              .search-input{
                background-color: #F2F6FC;
                border:0;
                height: 40px;
                line-height: 40px;
                border-radius: 4px;
                color: #606266;
                padding: 0 40px 0 15px;
                -webkit-appearance: none;
                font-size: 12px;
                width: 100%;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                outline: 0;
                &::-webkit-input-placeholder {
                  color: #C0C4CC;
                }
                &::-ms-input-placeholder {
                  color: #C0C4CC;
                }
              }
              .search-btn{
                position: absolute;
                right: 0;
                height: 40px;
                width: 40px;
                line-height: 40px;
                top: 0;
                border: 0;
                background: transparent;
                text-align: center;
                padding: 0;
              }
            }
          }
          .card-content{
            .group-filter{
              width: 100%;
              padding: 0 30px 0 0 ;
              margin: 0 ;
              position: relative;
              li{
                width: 100%;
                list-style: none;
                position: relative;
                padding-left: 20px;
                padding-top: 15px;
                padding-bottom: 15px;
                cursor: pointer;
                border-radius: 2px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                &.active{
                  background: #f5f7fa;
                  color:#409EFF;
                }
                &:hover{
                  color:#409EFF;
                }
              }
            }
            .el-table::before{
              height: 0!important;
            }
            .el-pagination{
              margin-top: 20px;
            }
          }
        }
      }
    }
  }
</style>
